import { fromZonedTime, format } from 'date-fns-tz';

const moscowTimeZone = 'Europe/Moscow';
const commentDateFormat = 'dd.MM.yyyy HH:mm';

export const formatDateForComment = (dateString) => {
  if (dateString == null) {
    return '';
  }

  const date = new Date(dateString);
  const utcDate = fromZonedTime(date, moscowTimeZone);
  const localDate = new Date(utcDate);

  return format(localDate, commentDateFormat);
};
